import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    Typography,
    Checkbox,
    FormControlLabel,
    Box,
    Stack,
    Divider
} from "@mui/material";
import { useEffect, useState } from "react";

const PlansCreateCards = ({
    plan_name,
    features,
    view,
    onFeatureSelectChange = () => { }
}) => {
    const normalFeatures = features?.filter((f) => f.is_addon === 0);
    const addOnFeatures = features?.filter((f) => f.is_addon === 1);

    const [ checkedItems, setCheckedItems ] = useState(Array(features.length).fill(false));
    const [ parentChecked, setParentChecked ] = useState(false);

    useEffect(() => {
        const selected = features.filter((_, index) => checkedItems[ index ]);
        const selectedIds = selected.map((feature) => feature.id);
        const totalCost = selected.reduce((acc, curr) => acc + parseFloat(curr.cost), 0);
        onFeatureSelectChange(selectedIds, totalCost);
    }, [ checkedItems ]);

    const handleParentCheck = (event) => {
        const isChecked = event.target.checked;
        setParentChecked(isChecked);
        setCheckedItems(Array(features.length).fill(isChecked));
    };

    const handleChildCheck = (index) => (event) => {
        const newCheckedItems = [ ...checkedItems ];
        newCheckedItems[ index ] = event.target.checked;
        setCheckedItems(newCheckedItems);
        setParentChecked(newCheckedItems.every(Boolean));
    };

    const renderViewList = (list, title) => (
        <Box>
            <Typography variant="subtitle1" sx={ { fontWeight: 800, mb: 2 } }>{ title }</Typography>
            <Stack spacing={ 1 }>
                { list?.map((feature) => (
                    <Typography key={ feature.id } sx={ { pl: 1 } }>
                        • { feature.feature_name }
                        {/* — ${feature.cost} */ }
                    </Typography>
                )) }
            </Stack>
        </Box>
    );

    return (
        <Accordion expanded>
            <AccordionSummary>
                { !view ? (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ parentChecked }
                                onChange={ handleParentCheck }
                                onClick={ (e) => e.stopPropagation() }
                            />
                        }
                        label={ <Typography variant="h6">{ plan_name }</Typography> }
                    />
                ) : (
                    <Typography variant="h6" sx={ { fontWeight: 600 } }>{ plan_name }</Typography>
                ) }
            </AccordionSummary>

            <AccordionDetails>
                { !view ? (
                    <Grid container spacing={ 2 }>
                        { features.map((feature, index) => (
                            <Grid item xs={ 12 } sm={ 6 } md={ 3 } key={ feature.id }>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={ checkedItems[ index ] }
                                            onChange={ handleChildCheck(index) }
                                        />
                                    }
                                    label={ `${feature.feature_name} — $${feature.cost}` }
                                />
                            </Grid>
                        )) }
                    </Grid>
                ) : (
                    <Grid container spacing={ 2 } alignItems="flex-start">
                        <Grid item xs={ 12 } md={ 5 }>
                            { renderViewList(normalFeatures, "Features") }
                        </Grid>

                        <Grid item md={ 1 } sx={ { display: { xs: "none", md: "flex" }, justifyContent: "center", zIndex: 10 } }>
                            <Divider orientation="vertical" sx={ { height: "100%", color: "black" } } />
                        </Grid>

                        <Grid item xs={ 12 } md={ 6 }>
                            { renderViewList(addOnFeatures, "Add-ons") }
                        </Grid>
                    </Grid>
                ) }
            </AccordionDetails>
        </Accordion>
    );
};

export default PlansCreateCards;